<div class="form-input-container">
    @if (progressTracker) {
        <div class="radiobox-progress-container">
            <div style="display:flex;">
                <input type="radio" id="{{myId}}" name="{{name}}" (change)="handleOnChanged($event)" style="border: 1px solid var(--green-800);" [style.cursor]="readonly ? 'auto' : 'pointer'" [checked]="checked" [disabled]="readonly" />
                <label for="{{myId}}" [hidden]="!label" style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-family: Booton; font-weight: 400; font-size: 12px; color: var(--green-800);">{{label}}</label>
            </div>
        </div> 
    } @else {
        @if (displayDirection == 'horizontal') {
        <div class="radiobox-container">
            <div style="display:flex;">
                <input type="radio" id="{{myId}}" name="{{name}}" (change)="handleOnChanged($event)" style="border: 1px solid var(--green-800);" [style.cursor]="readonly ? 'auto' : 'pointer'" [checked]="checked" [disabled]="readonly" />
                <label for="{{myId}}" [hidden]="!label" style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-family: Booton; font-weight: 400; font-size: 12px; color: var(--green-800);">{{label}}</label>
            </div>
        </div> 
        }
        @if (displayDirection == 'vertical') {
            <!-- vertical radiobox -->
            <div class="radiobox-container" style="flex-direction: column; gap:5px;">
                <div style="display:flex;">
                    <input type="radio" id="{{myId}}" name="{{name}}" (change)="handleOnChanged($event)" style="border: 1px solid var(--green-800);" [style.cursor]="readonly ? 'auto' : 'pointer'" [checked]="checked" [disabled]="readonly" />
                    <label for="{{myId}}" [hidden]="!label" style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-family: Booton; font-weight: 400; font-size: 12px; color: var(--green-800);">{{label}}</label>
                </div>
            </div>
        }    
    }
</div>
